<div class="row">
  <div class="col-12">
      <div class="content-header">Buttons</div>
  </div>
</div>

<!-- Basic Buttons start -->
<section id="basic-buttons">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic Buttons</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <!-- basic buttons -->
            <h6>Default</h6>
            <p>Use <code>.btn-&#123;color&#125;</code> along with <code>.btn</code> to create a button</p>
            <button type="button" class="btn btn-primary mr-1 mb-1">Primary</button>
            <button type="button" class="btn btn-secondary mr-1 mb-1">Secondary</button>
            <button type="button" class="btn btn-success mr-1 mb-1">Success</button>
            <button type="button" class="btn btn-danger mr-1 mb-1">Danger</button>
            <button type="button" class="btn btn-warning mr-1 mb-1">Warning</button>
            <button type="button" class="btn btn-info mr-1 mb-1">Info</button>
            <button type="button" class="btn btn-light mr-1 mb-1">Light</button>
            <button type="button" class="btn btn-dark mb-1">Dark</button>
            <hr>
            <!-- round buttons -->
            <h6>Rounded</h6>
            <p>Use <code>.round</code> for round buttons</p>
            <button type="button" class="btn btn-primary round mr-1 mb-1">Primary</button>
            <button type="button" class="btn btn-secondary round mr-1 mb-1">Secondary</button>
            <button type="button" class="btn btn-success round mr-1 mb-1">Success</button>
            <button type="button" class="btn btn-danger round mr-1 mb-1">Danger</button>
            <button type="button" class="btn btn-warning round mr-1 mb-1">Warning</button>
            <button type="button" class="btn btn-info round mr-1 mb-1">Info</button>
            <button type="button" class="btn btn-light round mr-1 mb-1">Light</button>
            <button type="button" class="btn btn-dark round mb-1">Dark</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Basic Buttons end -->

<!-- Basic Outline Buttons start -->
<section id="outline-buttons">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Outline Buttons</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <!-- basic buttons -->
            <h6>Default</h6>
            <p>Use <code>.btn-outline-&#123;color&#125;</code> to create an outline button</p>
            <button type="button" class="btn btn-outline-primary mr-1 mb-1">Primary</button>
            <button type="button" class="btn btn-outline-secondary mr-1 mb-1">Secondary</button>
            <button type="button" class="btn btn-outline-success mr-1 mb-1">Success</button>
            <button type="button" class="btn btn-outline-danger mr-1 mb-1">Danger</button>
            <button type="button" class="btn btn-outline-warning mr-1 mb-1">Warning</button>
            <button type="button" class="btn btn-outline-info mr-1 mb-1">Info</button>
            <button type="button" class="btn btn-outline-light mr-1 mb-1">Light</button>
            <button type="button" class="btn btn-outline-dark mb-1">Dark</button>
            <hr>
            <!-- round buttons -->
            <h6>Rounded</h6>
            <p>Use <code>.round</code> with outline button to create round outline button</p>
            <button type="button" class="btn btn-outline-primary round mr-1 mb-1">Primary</button>
            <button type="button" class="btn btn-outline-secondary round mr-1 mb-1">Secondary</button>
            <button type="button" class="btn btn-outline-success round mr-1 mb-1">Success</button>
            <button type="button" class="btn btn-outline-danger round mr-1 mb-1">Danger</button>
            <button type="button" class="btn btn-outline-warning round mr-1 mb-1">Warning</button>
            <button type="button" class="btn btn-outline-info round mr-1 mb-1">Info</button>
            <button type="button" class="btn btn-outline-light round mr-1 mb-1">Light</button>
            <button type="button" class="btn btn-outline-dark round mb-1">Dark</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Basic Outline Buttons end -->

<!-- Light Buttons starts -->
<section id="light-buttons">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Light Style</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <h6>Default</h6>
            <p>Use <code>.bg-light-&#123;color&#125;</code> to create light buttons</p>
            <button type="button" class="btn btn-primary bg-light-primary mr-1 mb-1">Primary</button>
            <button type="button" class="btn btn-secondary bg-light-secondary mr-1 mb-1">Secondary</button>
            <button type="button" class="btn btn-success bg-light-success mr-1 mb-1">Success</button>
            <button type="button" class="btn btn-danger bg-light-danger mr-1 mb-1">Danger</button>
            <button type="button" class="btn btn-warning bg-light-warning mr-1 mb-1">Warning</button>
            <button type="button" class="btn btn-info bg-light-info mb-1">Info</button>
            <hr>
            <h6>Rounded</h6>
            <p>Use <code>.round</code> with light button to create round light button</p>
            <button type="button" class="btn btn-primary bg-light-primary round mr-1 mb-1">Primary</button>
            <button type="button" class="btn btn-secondary bg-light-secondary round mr-1 mb-1">Secondary</button>
            <button type="button" class="btn btn-success bg-light-success round mr-1 mb-1">Success</button>
            <button type="button" class="btn btn-danger bg-light-danger round mr-1 mb-1">Danger</button>
            <button type="button" class="btn btn-warning bg-light-warning round mr-1 mb-1">Warning</button>
            <button type="button" class="btn btn-info bg-light-info round mb-1">Info</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Light Buttons ends -->

<!-- Basic Button Icon start -->
<section id="basic-button-icons">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Buttons with Icon </h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <button type="button" class="btn btn-outline-info mr-2 mb-1"><i class="fa fa-info mr-1"></i>Info</button>
            <button type="button" class="btn btn-warning mr-2 mb-1"><i class="fa fa-camera mr-1"></i>Warning</button>
            <button type="button" class="btn btn-success bg-light-success mb-1"><i class="fa fa-home mr-1"></i>Home</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Basic Button Icon end -->

<!-- Icon Buttons start -->
<section id="icons-buttons">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Icon Buttons</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.btn-icon</code> for icon buttons and <code>.btn-icon.round</code> for round icon buttons</p>
            <button type="button" class="btn btn-outline-info mr-1 mb-1"><i class="fa fa-search"></i></button>
            <button type="button" class="btn btn-warning mr-1 mb-1"><i class="fa fa-camera"></i></button>
            <button type="button" class="btn btn-success bg-light-success mr-3 mb-1"><i class="fa fa-heart"></i></button>
            <button type="button" class="btn btn-outline-info btn-icon round mr-1 mb-1"><i class="fa fa-search"></i></button>
            <button type="button" class="btn btn-warning btn-icon round mr-1 mb-1"><i class="fa fa-camera"></i></button>
            <button type="button" class="btn btn-success bg-light-success btn-icon round mr-1 mb-1"><i class="fa fa-heart"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Icon Buttons end -->

<!-- Basic Button group start -->
<section id="basic-button-group">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic Button group</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Group a series of buttons together on a single line with the button group. Wrap a series of buttons with <code>.btn</code> in <code>.btn-group</code></p>
            <div class="row">
              <div class="col-12 col-md-6 mb-2 mb-md-0">
                <!-- button group -->
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-primary">Left</button>
                  <button type="button" class="btn btn-outline-primary">Middle</button>
                  <button type="button" class="btn btn-outline-primary">Right</button>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <!-- icon button group -->
                <div class="btn-group" role="group">
                    <button type="button" class="btn btn-outline-primary"><i class="ft-facebook"></i></button>
                    <button type="button" class="btn btn-primary"><i class="ft-twitter"></i></button>
                    <button type="button" class="btn btn-outline-primary"><i class="ft-instagram"></i></button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Basic Button group end -->

<!-- Sizes starts -->
<section id="sizes-button">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Sizes</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <h6>Buttons</h6>
            <div class="row">
              <!-- button sizes -->
              <div class="col-12 col-md-6 mb-2 mb-md-0">
                <p>Add <code>.btn-lg</code> or <code>.btn-sm</code> for Fancy larger or smaller buttons size</p>
                <button type="button" class="btn btn-lg btn-primary mr-1 mb-2 mb-md-0">Large</button>
                <button type="button" class="btn btn-primary mr-1">Default</button>
                <button type="button" class="btn btn-sm btn-primary">Small</button>
              </div>
              <!-- outline button sizes -->
              <div class="col-12 col-md-6">
                <p>Add <code>.btn-lg</code> or <code>.btn-sm</code> with <code>.btn-outline</code> for Fancy larger or smaller outline buttons sizes</p>
                <button type="button" class="btn btn-lg btn-outline-primary mr-1">Large</button>
                <button type="button" class="btn btn-outline-primary mr-1">Default</button>
                <button type="button" class="btn btn-sm btn-outline-primary">Small</button>
              </div>
            </div>
            <hr>
            <h6>Button Groups</h6>
            <div class="row">
              <!-- button group large size -->
              <div class="col-12 col-md-6 mb-2 mb-md-0">
                <p>Add <code>.btn-group-lg</code> for larger button group size</p>
                <div class="btn-group btn-group-lg" role="group">
                  <button type="button" class="btn btn-primary mb-2 mb-md-0">Schedule</button>
                  <button type="button" class="btn btn-outline-primary mb-2 mb-md-0">Publish</button>
                </div>
              </div>
              <!-- button group small size -->
              <div class="col-12 col-md-6">
                <p>Add <code>.btn-group-sm</code> for smaller button group size</p>
                <div class="btn-group btn-group-sm" role="group">
                  <button type="button" class="btn btn-primary">Male</button>
                  <button type="button" class="btn btn-outline-primary">Female</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Sizes ends -->

<!-- Block level buttons start -->
<section id="block-level-buttons">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Block Level Buttons</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Create block level buttons—those that span the full width of a parent — by adding <code>.btn-block</code></p>
            <div class="row">
              <!-- block button -->
              <div class="col-12 col-md-6 mb-2 mb-md-0">
                <button type="button" class="btn btn-primary btn-block">Block Level Button</button>
              </div>
              <!-- block outline button -->
              <div class="col-12 col-md-6">
                <button type="button" class="btn btn-outline-primary btn-block">Block Level Button</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Block level buttons ends -->

<!-- Vertical variation starts -->
<section id="vertical-variation">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Vertical variation</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.btn-group-vertical</code> in the parent element of the buttons to create vertical button group</p>
            <div class="row">
              <div class="col-md-4 col-12 mb-3 mb-md-0">
                <h6>Vertical variation with different colors</h6>
                <div class="btn-group-vertical" role="group" aria-label="Vertical button group">
                  <button type="button" class="btn btn-primary">Primary</button>
                  <button type="button" class="btn btn-secondary">Secondary</button>
                  <button type="button" class="btn btn-success">Success</button>
                  <button type="button" class="btn btn-danger">Danger</button>
                  <button type="button" class="btn btn-warning">Warning</button>
                  <button type="button" class="btn btn-info">Info</button>
                </div>
              </div>
              <div class="col-md-4 col-12 mb-3 mb-md-0">
                <h6>Vertical variation with Outlines</h6>
                <div class="btn-group-vertical" role="group" aria-label="Vertical button group">
                  <button type="button" class="btn btn-outline-primary">Primary</button>
                  <button type="button" class="btn btn-outline-secondary">Secondary</button>
                  <button type="button" class="btn btn-outline-success">Success</button>
                  <button type="button" class="btn btn-outline-danger">Danger</button>
                  <button type="button" class="btn btn-outline-warning">Warning</button>
                  <button type="button" class="btn btn-outline-info">Info</button>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <h6>Vertical variation with Light Background</h6>
                <div class="btn-group-vertical" role="group" aria-label="Vertical button group">
                  <button type="button" class="btn btn-primary bg-light-primary">Primary</button>
                  <button type="button" class="btn btn-secondary bg-light-secondary">Secondary</button>
                  <button type="button" class="btn btn-success bg-light-success">Success</button>
                  <button type="button" class="btn btn-danger bg-light-danger">Danger</button>
                  <button type="button" class="btn btn-warning bg-light-warning">Warning</button>
                  <button type="button" class="btn btn-info bg-light-info">Info</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Vertical variation ends -->

<!-- Gradient Button starts -->
<section id="gradient-buttons">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Gradients</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-12 mb-3 mb-md-0">
                <h6>Gradient Buttons</h6>
                <div class="mb-2">
                  <button type="button" class="btn gradient-purple-bliss">Button</button>
                  <span class="ml-2"><code>.gradient-purple-bliss</code></span>
                </div>
                <div class="mb-2">
                  <button type="button" class="btn gradient-mint">Button</button>
                  <span class="ml-2"><code>.gradient-mint</code></span>
                </div>
                <div class="mb-2">
                  <button type="button" class="btn gradient-pomegranate">Button</button>
                  <span class="ml-2"><code>.gradient-pomegranate</code></span>
                </div>
                <div class="mb-2">
                  <button type="button" class="btn gradient-ibiza-sunset">Button</button>
                  <span class="ml-2"><code>.gradient-ibiza-sunset</code></span>
                </div>
                <div>
                  <button type="button" class="btn gradient-king-yna">Button</button>
                  <span class="ml-2"><code>.gradient-king-yna</code></span>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <h6>Gradient Buttons With Shadow</h6>
                <div class="mb-2">
                  <button type="button" class="btn gradient-purple-bliss shadow-z-1-hover">Button with Shadow</button>
                  <span class="ml-2"><code>.shadow-z-1-hover</code></span>
                </div>
                <div class="mb-2">
                  <button type="button" class="btn gradient-mint shadow-z-4">Button with Shadow</button>
                  <span class="ml-2"><code>.shadow-z-4</code></span>
                </div>
                <div class="mb-2">
                  <button type="button" class="btn gradient-pomegranate big-shadow">Button with Shadow</button>
                  <span class="ml-2"><code>.big-shadow</code></span>
                </div>
                <div class="mb-2">
                  <button type="button" class="btn gradient-ibiza-sunset sidebar-shadow">Button with Shadow</button>
                  <span class="ml-2"><code>.sidebar-shadow</code></span>
                </div>
                <div>
                  <button type="button" class="btn gradient-king-yna card-shadow">Button with Shadow</button>
                  <span class="ml-2"><code>.card-shadow</code></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Gradient Button ends -->

<!-- Social Media button starts -->
<section id="social-buttons">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Social Media Buttons</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 mb-2 mb-md-0">
                <h6>Default Buttons</h6>
                <p>Use <code>.btn-social</code> and <code>.btn-&#123;social-media&#125;</code> like <code>.btn-facebook</code> for social buttons with icons. Add <code>.round</code> for round button.</p>
                <p>
                  <button type="button" class="btn btn-social btn-facebook mr-2"><i class="fa fa-facebook"></i>Facebook</button>
                  <button type="button" class="btn btn-social btn-twitter"><i class="fa fa-twitter"></i>Twitter</button>
                </p>
                <p>
                  <button type="button" class="btn btn-social btn-google round mr-2"><i class="fa fa-google"></i>Google</button>
                  <button type="button" class="btn btn-social btn-instagram round"><i class="fa fa-instagram"></i>Instagram</button>
                </p>
              </div>
              <div class="col-12 col-md-6">
                <h6>Outline Buttons</h6>
                <p>Use <code>.btn-social</code> and <code>.btn-outline-&#123;social-media&#125;</code> like <code>.btn-outline-linkedin</code> for social buttons with icons. Add <code>.round</code> for round button.</p>
                <p>
                  <button type="button" class="btn btn-social btn-outline-linkedin mr-2"><i class="fa fa-linkedin"></i>LinkedIn</button>
                  <button type="button" class="btn btn-social btn-outline-reddit"><i class="fa fa-reddit"></i>Reddit</button>
                </p>
                <p>
                  <button type="button" class="btn btn-social btn-outline-pinterest round mr-2"><i class="fa fa-pinterest"></i>Pinterest</button>
                  <button type="button" class="btn btn-social btn-outline-dropbox round"><i class="fa fa-dropbox"></i>Dropbox</button>
                </p>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-12 col-md-6 mb-2 mb-md-0">
                <h6>Default Icon Buttons</h6>
                <p>Use <code>.btn-social-icon</code> and <code>.btn-&#123;social-media&#125;</code> like <code>.btn-facebook</code> for social icon buttons. Add <code>.round</code> for round button.</p>
                <p>
                  <button type="button" class="btn btn-social-icon btn-facebook mr-2"><i class="fa fa-facebook"></i></button>
                  <button type="button" class="btn btn-social-icon btn-twitter mr-2"><i class="fa fa-twitter"></i></button>
                  <button type="button" class="btn btn-social-icon btn-google round mr-2"><i class="fa fa-google"></i></button>
                  <button type="button" class="btn btn-social-icon btn-instagram round"><i class="fa fa-instagram"></i></button>
                </p>
              </div>
              <div class="col-12 col-md-6">
                <h6>Outline Icon Buttons</h6>
                <p>Use <code>.btn-social-icon</code> and <code>.btn-outline-&#123;social-media&#125;</code> like <code>.btn-outline-linkedin</code> for social icon buttons. Add <code>.round</code> for round button.</p>
                <p>
                  <button type="button" class="btn btn-social-icon btn-outline-linkedin mr-2"><i class="fa fa-linkedin"></i></button>
                  <button type="button" class="btn btn-social-icon btn-outline-reddit mr-2"><i class="fa fa-reddit"></i></button>
                  <button type="button" class="btn btn-social-icon btn-outline-pinterest round mr-2"><i class="fa fa-pinterest"></i></button>
                  <button type="button" class="btn btn-social-icon btn-outline-dropbox round"><i class="fa fa-dropbox"></i></button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Social Media button ends -->
